import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  const isBrowser = isPlatformBrowser(platformId);

  if (!isBrowser) {
    return router.parseUrl('/login');
  }

  const token = localStorage.getItem('jwtToken');

  if (token) {
    return true;
  } else {
    localStorage.removeItem('jwtToken');
    return router.parseUrl('/login');
  }
};
